import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Body, Box, Button, Heading } from '@hover/blueprint';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { historyContext } from 'src/modules/designStudio/providers';
import { SlideUpCard } from 'src/shared/components/SlideUpCard';

import { CardHeader } from '../CardHeader';

const Card = styled(SlideUpCard)`
  background-color: #f6f6f6;
`;
interface PropTypes {
  closeMenu: () => void;
  bodyText: string | undefined;
  headerText: string;
}

const ResetCard = ({ closeMenu, bodyText, headerText }: PropTypes) => {
  const { resetDesign } = useContext(historyContext);
  const onPress = () => {
    resetDesign();
    closeMenu();
  };
  return (
    <Card>
      <CardHeader leftActionHandler={closeMenu} leftIcon={faChevronLeft} />
      <Box alignSelf="center">
        <Heading marginBottom={0} size={400} textAlign="center">
          {headerText}
        </Heading>
      </Box>
      <Box alignSelf="center" marginBottom={200}>
        <Body size={400} textAlign="center">
          {bodyText}
        </Body>
      </Box>
      <Box alignSelf="center" justifyContent="space-around" width="100%">
        <Button height={44} onPress={onPress} width={110}>
          Yes
        </Button>
        <Button fill="outline" height={44} onPress={closeMenu} width={110}>
          No
        </Button>
      </Box>
    </Card>
  );
};

export { ResetCard };
